import { Icon, Stack } from '@backyard-ui/core';
import { AlertTriangle, CheckmarkCircle } from '@backyard-ui/icons';

import { type ZipCodeStatus } from '../constants';

import { styles } from './HelperText.styles';

const ICON_BY_STATE: Record<ZipCodeStatus['state'], JSX.Element | null> = {
  valid: <CheckmarkCircle />,
  invalid: <AlertTriangle />,
  idle: null,
  loading: null,
};

interface HelperTextProps {
  status: ZipCodeStatus;
}

const HelperText = (props: Readonly<HelperTextProps>) => {
  const {
    status: { hint, state },
  } = props;

  const icon = ICON_BY_STATE[state];

  return (
    <Stack
      align="center"
      spacing="1"
      className={styles({
        state,
      })}
    >
      {icon && (
        <Icon size="xs" data-testid={`${state}-status-icon`}>
          {icon}
        </Icon>
      )}
      <span>{hint}</span>
    </Stack>
  );
};

export default HelperText;
